//settings dayjs:
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/ru';
dayjs.extend(utc);
dayjs.locale('ru');

export const getLastYears = (count = 4) => {
  const currentYear = dayjs().year();
  return Array.from({ length: count }, (_, i) => currentYear - i);
};

export const getLastMonths = (count = 12) => {
  const now = dayjs();
  const months = [];

  for (let i = 0; i < count; i++) {
    const date = now.subtract(i, 'month');
    months.push({
      val: date.month(),
      year: date.year(),
      opt: date.format('MMMM YYYY'),
    });
  }
  return months;
};

export function getFromTo({ month, year, day }) {
  let from, to;

  if (day !== undefined && month !== undefined) {
    from = new Date(Date.UTC(year, month, day, 0, 0, 0));
    to = new Date(Date.UTC(year, month, day, 23, 59, 59));
  } else if (month !== undefined) {
    from = new Date(Date.UTC(year, month, 1, 0, 0, 0));
    to = new Date(Date.UTC(year, month + 1, 0, 23, 59, 59));
  } else {
    from = new Date(Date.UTC(year, 0, 1, 0, 0, 0));
    to = new Date(Date.UTC(year, 11, 31, 23, 59, 59));
  }
  const format = (d) => d.toISOString().split('.')[0] + '+03:00';

  return {
    from: format(from),
    to: format(to),
  };
}

export const calculateConsumption = (data) => {
  if (!data.length) return 0;
  const startValue = data[0]?.value || 0;
  const endValue = data.at(-1)?.value || 0;
  return (endValue - startValue).toFixed(2);
};
